<ng-content select="ts-drawer-header"></ng-content>
<div class="ts-drawer__inner-container">
  <ng-content></ng-content>
</div>
<ng-content select="ts-drawer-footer"></ng-content>
